const mainsData = [
  {
    section: "General Structure",
    description: "9 Papers total",
    points: [
      "Paper A & B (Qualifying – not counted for ranking)",
      "Papers I to VII (Counted for merit)",
    ],
  },
  {
    section: "Qualifying Papers",
    description:
      "The aim of the paper is to test the candidates' ability to read and understand serious discursive prose, and to express ideas clearly and correctly, in English and Indian language concerned.",
    papers: [
      {
        title: "Paper A – Indian Language (300 Marks)",
        desc: [
          "Any one of the languages listed in the 8th Schedule of the Constitution (except for candidates exempted).",
          "Candidates are required to select any one of the Indian languages listed in the Eighth Schedule of the Indian Constitution. This paper assesses a candidate’s proficiency in reading and comprehending serious discursive prose and their ability to articulate ideas clearly and accurately in the chosen language.",
          "The pattern of questions would be broadly as follows:",
        ],
        details: [
          "1. Comprehension of given passages.",
          "2. Precis Writing.",
          "3. Usage and Vocabulary.",
          "4. Short Essays.",
        ],
        tableTitle: "Languages Included in the Eighth Schedule:",
        tableData: [
          [
            "1. Assamese",
            "6. Kashmiri",
            "11. Nepali",
            "16. Tamil",
            "21. Maithili",
          ],
          [
            "2. Bengali",
            "7. Konkani",
            "12. Odia",
            "17. Telugu",
            "22. Santhali",
          ],
          ["3. Gujarati", "8. Malayalam", "13. Punjabi", "18. Urdu"],
          ["4. Hindi", "9. Manipuri", "14. Sanskrit", "19. Bodo"],
          ["5. Kannada", "10. Marathi", "15. Sindhi", "20. Dogri"],
        ],
      },
      {
        title: "Paper B – English (300 Marks)",
        desc: [
          "The English language paper evaluates a candidate’s comprehension of serious discursive writing and their ability to express ideas with clarity, coherence, and grammatical accuracy in English.",
        ],
        details: [
          "Note 1: The papers on Indian Languages and English will be of Matriculation or equivalent standard and will be of qualifying nature only. The marks obtained in these papers will not be counted for ranking.",
          "Note 2: The candidates will have to answer the English and Indian Languages papers in English and the respective Indian language (except where translation is involved).",
          "Note 3:The candidates will have to answer the English and Indian Languages papers in English and the respective Indian language (except where translation is involved).",
        ],
      },
    ],
  },
  {
    section: "Merit Papers",
    description: "Paper I to VII are counted for merit.",
    papers: [
      {
        title: "Paper I – Essay (250 Marks)",
        subtitle: "Essay (250 Marks)",
        content: [
          "Candidates may be required to write essays on multiple topics. They will be expected to keep closely to the subject of the essay to arrange their ideas in orderly fashion, and to write concisely. Credit will be given for effective and exact expression.",
        ],
      },
      {
        title: "Paper II – General Studies I (250 Marks)",
        subtitle:
          "Indian Heritage & Culture, History, Geography of the World & Society",
        details: [
          "Indian culture: Art forms, literature, architecture from ancient to modern times",
          "Modern Indian history: Significant events, personalities, issues (18th century onwards)",
          "Freedom struggle: Different stages, important contributors/contributions from different parts of the country.",
          "Post-independence consolidation and reorganisation within the country.",
          "World history: 18th century onwards (industrial revolution, world wars, redrawal of national boundaries, colonization, decolonization, political philosophies like communism, capitalism, socialism etc.— their forms and effect on the society).",
          "Salient features of Indian Society, Diversity of India.",
          "Role of women and women’s organization, population and associated issues, poverty and developmental issues, urbanization, their problems and their remedies.",
          "Effects of globalization on Indian society.",
          "Social empowerment, communalism, regionalism & secularism.",
          "Salient features of world’s physical geography",
          "Distribution of key natural resources across the world (including South Asia and the Indian sub continent); factors responsible for the location of primary, secondary, and tertiary sector industries in various parts of the world (including India). ",
          "Important Geophysical phenomena such as earthquakes, Tsunami, Volcanic activity, cyclone etc., geographical features and their location-changes in critical geographical features (including water-bodies and ice-caps) and in flora and fauna and the effects of such changes.",
        ],
      },
      {
        title: "Paper III – General Studies II (250 Marks)",
        subtitle:
          "Governance, Constitution, Polity, Social Justice & International Relations",
        details: [
          "Indian Constitution—historical underpinnings, evolution, features, amendments, significant provisions and basic structure.",
          "Functions and responsibilities of the Union and the States, issues and challenges pertaining to the federal structure, devolution of powers and finances up to local levels and challenges therein.",
          "Separation of powers between various organs dispute redressal mechanisms and institutions. • Comparison of the Indian constitutional scheme with that of other countries.",
          "Parliament and State legislatures—structure, functioning, conduct of business, powers & privileges and issues arising out of these.",
          "Structure, organization and functioning of the Executive and the Judiciary—Ministries and Departments of the Government; pressure groups and formal/informal associations and their role in the Polity.",
          "Salient features of the Representation of People’s Act.",
          "Appointment to various Constitutional posts, powers, functions and responsibilities of various Constitutional Bodies.",
          "Statutory, regulatory and various quasi-judicial bodies.",
          "Government policies and interventions for development in various sectors and issues arising out of their design and implementation.",
          "Development processes and the development industry —the role of NGOs, SHGs, various groups and associations, donors, charities, institutional and other stakeholders.",
          "Welfare schemes for vulnerable sections of the population by the Centre and States and the performance of these schemes; mechanisms, laws, institutions and Bodies constituted for the protection and betterment of these vulnerable sections.",
          "Issues relating to development and management of Social Sector/Services relating to Health, Education, Human Resources.",
          "Issues relating to poverty and hunger.",
          "Important aspects of governance, transparency and accountability, e-governance- applications, models, successes, limitations, and potential; citizens charters, transparency & accountability and institutional and other measures.",
          "Role of civil services in a democracy.",
          "India and its neighborhood- relations.",
          "Bilateral, regional and global groupings and agreements involving India and/or affecting India’s interests.",
          "Effect of policies and politics of developed and developing countries on India’s interests, Indian diaspora.",
          "Important International institutions, agencies and fora- their structure, mandate.",
        ],
      },
      {
        title: "Paper IV – General Studies III (250 Marks)",
        subtitle:
          "Technology, Economic Development, Biodiversity, Environment, Security & Disaster Management",
        details: [
          "Indian Economy and issues relating to planning, mobilization, of resources, growth, development and employment.",
          "Inclusive growth and issues arising from it.",
          "Government Budgeting.",
          "Major crops-cropping patterns in various parts of the country, - different types of irrigation and irrigation systems storage, transport and marketing of agricultural produce and issues and related constraints; e-technology in the aid of farmers.",
          "Issues related to direct and indirect farm subsidies and minimum support prices; Public Distribution System- objectives, functioning, limitations, revamping; issues of buffer stocks and food security; Technology missions; economics of animal-rearing.",
          "Food processing and related industries in India- scope’ and significance, location, upstream and downstream requirements, supply chain management.",
          "Land reforms in India.",
          "Effects of liberalization on the economy, changes in industrial policy and their effects on industrial growth.",
          "Infrastructure: Energy, Ports, Roads, Airports, Railways etc.",
          "Investment models.",
          "Science and Technology- developments and their applications and effects in everyday life.",
          "Achievements of Indians in science & technology; indigenization of technology and developing new technology.",
          "Awareness in the fields of IT, Space, Computers, robotics, nano-technology, bio-technology and issues relating to intellectual property rights.",
          "Conservation, environmental pollution and degradation, environmental impact assessment.",
          "Disaster and disaster management.",
          "Linkages between development and spread of extremism.",
          "Role of external state and non-state actors in creating challenges to internal security.",
          "Challenges to internal security through communication networks, role of media and social networking sites in internal security challenges, basics of cyber security; money-laundering and its prevention.",
          "Security challenges and their management in border areas - linkages of organized crime with terrorism.",
          "Various Security forces and agencies and their mandate.",
        ],
      },
      {
        title: "Paper V – General Studies IV (250 Marks)",
        subtitle: "Ethics, Integrity & Aptitude",
        details: [
          "This paper will include questions to test the candidates’ attitude and approach to issues relating to integrity, probity in public life and his problem solving approach to various issues and conflicts faced by him in dealing with society. Questions may utilise the case study approach to determine these aspects. The following broad areas will be covered:",
          "Ethics and Human Interface: Essence, determinants and consequences of Ethics in-human actions; dimensions of ethics; ethics - in private and public relationships. Human Values - lessons from the lives and teachings of great leaders, reformers and administrators; role of family society and educational institutions in inculcating values.",
          "Attitude: content, structure, function; its influence and relation with thought and behaviour; moral and political attitudes; social influence and persuasion.",
          "Aptitude and foundational values for Civil Service, integrity, impartiality and non-partisanship, objectivity, dedication to public service, empathy, tolerance and compassion towards the weaker-sections.",
          "Emotional intelligence-concepts, and their utilities and application in administration and governance.",
          "Contributions of moral thinkers and philosophers from India and world.",
          "Public/Civil service values and Ethics in Public administration: Status and problems; ethical concerns and dilemmas in government and private institutions; laws, rules, regulations and conscience as sources of ethical guidance; accountability and ethical governance; strengthening of ethical and moral values in governance; ethical issues in international relations and funding; corporate governance. ",
          "Probity in Governance: Concept of public service; Philosophical basis of governance and probity; Information sharing and transparency in government, Right to Information, Codes of Ethics, Codes of Conduct, Citizen’s Charters, Work culture, Quality of service delivery, Utilization of public funds, challenges of corruption.",
          "Case Studies on above issues.",
        ],
      },
      {
        title:
          "Paper VI & VII – Optional Subject Papers I & II (250 Marks each)",
        details: [
          "Candidate chooses one optional subject (2 papers).",
          "Examples: Anthropology, Geography, History, Sociology, Political Science, Public Administration, etc.",
        ],
      },
    ],
  },
  {
    section: "Personality Test / Interview (275 Marks)",

    points: [
      "Assesses candidate’s personality, mental calibre, analytical ability, leadership, judgment, and moral integrity.",
    ],
  },
];

export default mainsData;
